import config from "@config";

export const getUiSchema = ({
  t,
  clientId,
  onSelectChairedBy,
  onSelectHrRepresentative,
  fileNames,
}: {
  t: (id: string, obj?: Object) => string,
  clientId: number,
  onSelectChairedBy?: Function,
  onSelectHrRepresentative?: Function,
  fileNames?: Array<string>,
}) => {
  return {
    hearingDate: {
      "ui:header": t("HEARING_DETAILS"),
      "ui:widget": "date-picker",
      "ui:options": {
        dateFormat: config.dateTimeFormat,
        fieldOverflow: "unset",
        header: {
          backgroundColor: "white",
          type: "h5",
          padding: "0",
        },
      },
    },
    hrRepresentative: {
      "ui:widget": "select",
      "ui:options": {
        onSelect: onSelectHrRepresentative,
        fieldOverflow: "unset",
        asyncOptions: {
          optionsUrl: `api/v1/employee-admin/client/${clientId}/employee`,
          optionValueKey: "id",
          labelKeys: ["firstName", "lastName"],
          searchField: "last_name",
          sort: "last_name,asc",
        },
      },
    },
    hearingChairedBy: {
      "ui:widget": "select",
      "ui:options": {
        onSelect: onSelectChairedBy,
        fieldOverflow: "unset",
        asyncOptions: {
          optionsUrl: `api/v1/employee-admin/client/${clientId}/employee`,
          optionValueKey: "id",
          labelKeys: ["firstName", "lastName"],
          searchField: "last_name",
          sort: "last_name,asc",
        },
      },
    },
    documents: {
      "ui:widget": "file-input",
      "ui:options": {
        accept: [
          "application/pdf",
          "application/zip",
          "text/csv",
          "text/plain",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-powerpoint",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ].join(","),
        multiple: true,
        fileNames,
        className: "file-input-text-hidden",
      },
    },
  };
};
